export default __webpack_public_path__ + "static/media/icomoon.45e1b6c1.svg";